export default {
  SET_DESIGNS(state, payload) {
    state.designs = payload;
  }
};
